import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

interface MagnifyImageProps {
  blockId: string;
  title: string;
  imageSrc: string;
  altText?: string;
  buttonText: string;
  closeButtonText: string;
}

const MagnifyImage: React.FC<MagnifyImageProps> = ({ blockId, title, imageSrc, altText, buttonText, closeButtonText }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleOpen = () => setShow(true);

  return (
    <>
      <button
        type="button"
        className="openMagnifiedImage fa fa-search"
        onClick={handleOpen}
        data-blockid={blockId}
      >
        <span>{buttonText}</span>
      </button>

      <Modal
        id="MagnifyImage"
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard
        data-modalblockid={blockId}
      >
        <Modal.Body className="text-center">
          <img title={title} src={imageSrc} alt={altText || 'Magnified'} className="img-fluid magnifyImage" />
          <div className="buttonBox">
            <button className="closeMagnifiedImage fa fa-times-circle" onClick={handleClose}><span className="sr-only">{closeButtonText}</span></button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MagnifyImage;